import type {DynamicIframeParams} from '../types';

export const encodeFrameParams = ({
  livemode,
  disabledWalletProviders,
  enableSmartContractWalletDetection,
}: DynamicIframeParams): string => {
  const params = new URLSearchParams();
  params.append('livemode', livemode.toString());
  disabledWalletProviders.forEach((value) => {
    params.append('disabledWalletProviders', value);
  });
  params.append(
    'enableSmartContractWalletDetection',
    enableSmartContractWalletDetection.toString(),
  );
  return params.toString();
};

export const getFrameSrc = (params: DynamicIframeParams) => {
  let hostAndPath;

  if (window.location.hostname.endsWith('-mydev.dev.stripe.me')) {
    const devbox = !process.env.DEVBOX_QUALIFIER
      ? `${process.env.STRIPE_USER}`
      : `${process.env.STRIPE_USER}-${process.env.DEVBOX_QUALIFIER}-`;
    hostAndPath = `https://${devbox}-crypto_standalone_site-mydev.dev.stripe.me/wallet_connect_inner`;
  } else if (window.location.hostname.endsWith('.tunnel.stripe.me')) {
    hostAndPath = `https://${process.env.STRIPE_USER}-crypto-standalone-site.tunnel.stripe.me/wallet_connect_inner`;
  } else {
    // Use the same domain as the parent page to support both crypto.stripe.com and qa-crypto.stripe.com
    const trustedHosts = ['crypto.stripe.com', 'qa-crypto.stripe.com'];
    const host = trustedHosts.includes(window.location.hostname)
      ? window.location.hostname
      : 'crypto.stripe.com';
    hostAndPath = `https://${host}/wallet_connect_inner`;
  }

  return new URL(`${hostAndPath}?${encodeFrameParams(params)}`);
};
